import styled from 'styled-components'

export const IconWrapper = styled.span`
  cursor: pointer;
  font-size: 18px;
  color: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #40a9ff;
  }
`

export const NotesContent = styled.div`
  max-width: 400px;
  max-height: 300px;
  overflow-y: auto;
  color: #fff;
`

export const NoteItem = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  
  &:last-child {
    border-bottom: none;
  }
`

export const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
`

export const NoteText = styled.div`
  font-size: 14px;
  color: #fff;
  white-space: pre-wrap;
  word-wrap: break-word;
`

export const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 5px 0 4px;
`

